import { useTravelTranslation } from '../../app/TravelLocaleContext';

/** 將 0～1 費率轉成整數百分比字串（例 0.05 → "5%"）。 */
export function formatPlatformFeePercent(rate) {
  const n = Number(rate);
  if (!Number.isFinite(n) || n < 0) return '0%';
  const pct = Math.round(n * 10000) / 100;
  return `${pct % 1 === 0 ? String(pct) : String(pct)}%`;
}

/**
 * Host 事前佣金揭示（TRAVEL-FEE-PRODUCTION-PREFLIGHT-01）。
 * @param {{ feeEnabled?: boolean, vip?: boolean, platformFeeRate?: string|number, includedInDisplayPrice?: boolean, freeTripHint?: boolean, loadFailed?: boolean }} props
 */
export default function HostCommissionDisclosure({
  feeEnabled = false,
  vip = false,
  platformFeeRate = 0,
  includedInDisplayPrice = true,
  freeTripHint = false,
  loadFailed = false,
}) {
  const { t, tf } = useTravelTranslation();

  if (loadFailed) {
    return (
      <section className="group-trips__commission" role="status" data-testid="host-commission-disclosure">
        <p>{t('travel.vip.fee.disclosureLoadFailed')}</p>
      </section>
    );
  }

  const rateLabel = formatPlatformFeePercent(platformFeeRate);
  const rateCopy = feeEnabled && vip
    ? tf('travel.vip.fee.platformFeeRateVip', { rate: rateLabel })
    : tf('travel.vip.fee.platformFeeRate', { rate: rateLabel });

  return (
    <section className="group-trips__commission" role="status" data-testid="host-commission-disclosure">
      <h2 className="group-trips__commission-title">{t('travel.vip.fee.disclosureTitle')}</h2>
      <p>{rateCopy}</p>
      {includedInDisplayPrice ? <p>{t('travel.vip.fee.includedInDisplayPrice')}</p> : null}
      {feeEnabled ? <p>{t('travel.vip.fee.hostReceivableHint')}</p> : null}
      {freeTripHint ? <p>{t('travel.vip.fee.freeTripNoFee')}</p> : null}
    </section>
  );
}
